export const API_ENDPOINTS = {
    PROVIDERS: {
        GET_PROVIDERTYPE_BY_ID: "ProviderType/GetById",
        SEARCH_PROVIDERTYPE: "ProviderType/Search",
        SAVE_PROVIDERTYPE: "ProviderType/Save",
        UPDATE_PROVIDERTYPE: "ProviderType/Update",
        DELETE_PROVIDERTYPE: "ProviderType/Delete",
        EXPORT_PROVIDERTYPE: "ProviderType/Export",

        GET_MEDICALPROVIDER_BY_ID: "/MedicalProvider/GetById",
        SEARCH_MEDICALPROVIDER: "MedicalProvider/Search",
        SAVE_MEDICALPROVIDER: "MedicalProvider/Save",
        UPDATE_MEDICALPROVIDER: "MedicalProvider/Update",
        DELETE_MEDICALPROVIDER: "MedicalProvider/Delete",
        ACTIVE_MEDICALPROVIDER: "MedicalProvider/Activate",
        INACTIVE_MEDICALPROVIDER: "MedicalProvider/Inactivate",
        EXPORT_MEDICALPROVIDER: "MedicalProvider/EXPORT",

        GET_USERS: "MedicalProvider/GetUsers",

        GET_MEDICALPROVIDER_SERVICESITEMS_PRICING: "MedicalProvider/GetServiceItemPricing",
        SAVE_BULK_MEDICALPROVIDER_SERVICE_ITEM_PRICING: "/MedicalProvider/SaveBulk",
        UPDATE_MEDICALPROVIDER_SERVICE_ITEM: "/MedicalProvider/UpdateServiceItem",
        DELETE_MEDICALPROVIDER_SERVICE_ITEM: "/MedicalProvider/DeleteServiceItem",

        CLAIM_SAVE: "/Claim/Save",
        CLAIM_UPDATE: "/Claim/Update",
        CLAIM_DELETE: '/Claim/Delete',
        CLAIM_GET_BY_ID: '/Claim/GetById',
        CLAIM_SEARCH: "/Claim/Search",

        GET_TPA_CATEGORY_ITEMS: "MedicalProvider/GetTpaCategoriesWithItems"
        // Add other  endpoints here

    },

    // Add other modules like EMPLOYEE, DEPARTMENT etc.
};

export const QUERY_KEYS = {
    PROVIDERS: {    
        PROVIDERTYPE: ["ProviderTypeSearch"], // UNIQUE IN OVER ALL APPLICATION
        MEDICALPROVIDERS: ["MedicalProviderSearch"],
        MEDICALPROVIDER_SERVICE_ITEM_PRICING: ["MedicalProviderServiceItemPriceSearch"],
        MEDICAL_PROVIDERS_CLAIM: ["MedicalProviderClaimSearch"],
        MEDICAL_PROVIDERS_PRICE: ["MedicalProviderPriceSearch"],
        GET_MEDICAL_PROVIDERS_DETAIL: ["MedicalProviderDetail"],
    },

};